export enum FORM_CASES {
  MY_RELEASE_ON_ANOTHER_PAGE = 'my-release-on-another-page',
  ANOTHER_ARTIST_ON_MY_PAGE = 'another-artist-on-my-page',
  MOVE_MY_RELEASE = 'move-release-to-another-artist-page',
}

export type FormValues = {
  email: string;
  albumURIs: string;
  artistName: string;
  comments: string;
  case: FORM_CASES;
  destinationArtistURI: string;
  incorrectArtistURI: string;
  myArtistURI: string;
  currentArtistURI: string;
};
